<div class="modal-header">
    <h5 class="modal-title" id="editLiaisonTitle">Edit Liaison</h5>
    <button (click)="dismiss()" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
</div>
<div class="modal-body">
    <form [formGroup]="manageLiaisonForm">
        <div class="row gx-3">
            <div class="col-md-6 mb-3">
                <label for="liaison1" class="form-label">Liaison First Name<sup class="text-danger">*</sup></label>
                <input formControlName="firstName" type="text" class="form-control" id="liaison1" placeholder="First Name" required>
                <div *ngIf="firstNameCtrl.invalid && (firstNameCtrl.dirty || firstNameCtrl.touched)" class="invalid-feedback">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
            <div class="col-md-6 mb-3">
                <label for="liaison2" class="form-label">Liaison Last Name<sup class="text-danger">*</sup></label>
                <input formControlName="lastName" type="text" class="form-control" id="liaison2" placeholder="Last Name" required>
                <div *ngIf="lastNameCtrl.invalid && (lastNameCtrl.dirty || lastNameCtrl.touched)" class="invalid-feedback">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
        </div>
        <div class="row gx-3">
            <div class="col-12 mb-3">
                <label for="liaison3" class="form-label">Liaison Email Address<sup class="text-danger">*</sup></label>
                <input formControlName="emailAddress" type="email" class="form-control" id="liaison3" placeholder="Email Address" required>
                <div *ngIf="emailAddressCtrl.invalid && (emailAddressCtrl.dirty || emailAddressCtrl.touched)" class="invalid-feedback">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
        </div>
        <div class="row gx-3">
            <div class="col-12 mb-3">
                <label for="liaison4" class="form-label">Liaison Phone<sup class="text-danger">*</sup></label>
                <input formControlName="phoneNumber" mask="(000) 000-0000" type="text" class="form-control" id="liaison4" placeholder="Phone Number" required>
                <div *ngIf="phoneNumberCtrl.invalid && (phoneNumberCtrl.dirty || phoneNumberCtrl.touched)" class="invalid-feedback">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
        </div>
        <div class="row gx-3">
            <div class="col-12 mb-3">
                <label for="liaison5" class="form-label">Liaison Job Title</label>
                <input formControlName="jobTitle" type="text" class="form-control" id="liaison5" placeholder="Job Title" required>
                <!-- <div *ngIf="jobTitleCtrl.invalid && (jobTitleCtrl.dirty || jobTitleCtrl.touched)" class="invalid-feedback">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div> -->
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" (click)="saveLiaison()" class="btn btn-sb border-lb text-strong text-uppercase m-100">Save</button>
    <button type="button" (click)="dismiss()" class="btn btn-cancel text-strong text-uppercase m-100">Cancel</button>
</div>